webpackJsonp([1],{

/***/ "3jmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bK5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GyIF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f86d1c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("7bK5")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9f86d1c4"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b6b8dd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("rIu8")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e693742","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("GyIF")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutubeOrOlympics: function isYoutubeOrOlympics() {
      return this.videoURL.search('youtube') !== -1 || this.videoURL.search('olympic') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c81c71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutubeOrOlympics)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("3jmS")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fb97f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("V+ca")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Cartier Philanthropy Annual Report 2024-2025",
  "shortTitle": "",
  "description": "",
  "width": 1404,
  "height": 873,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "#"
  }],
  "basePath": "/AR2024-25",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://reports.cartierphilanthropy.org/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/AR2024-25/static/_content/Cartier-Philanthropy-Annual-Report-2024-25.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 1-logo\" style=\"top:273px;left:958px;\" src=\"/AR2024-25/static/_content/1-logo-1.png\"/>\n      <img class=\"abs halfScaleC 1-title\" style=\"top:546px;left:956px;\" src=\"/AR2024-25/static/_content/1-title-1.png\"/>\n      <img class=\"abs halfScaleC 1-title\" style=\"top:760px;left:1047px;\" src=\"/AR2024-25/static/_content/1-title-2.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-logo\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .staggerFromTo(cOf(\"1-title\"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.2);\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "A N N U A L R E PO RT 2024 - 2025"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"abs halfScaleC 2-title\" style=\"top:129px;left:98px;\" src=\"/AR2024-25/static/_content/2-title-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(3);\" style=\"top:373px; left:323px; width:499px; height:80px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(4);\" style=\"top:461px; left:323px; width:499px; height:80px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(6);\" style=\"top:547px; left:323px; width:499px; height:98px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(9);\" style=\"top:654px; left:323px; width:499px; height:96px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(12);\" style=\"top:130px; left:854px; width:499px; height:68px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(13);\" style=\"top:203px; left:854px; width:499px; height:181px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(22);\" style=\"top:389px; left:854px; width:499px; height:137px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(29);\" style=\"top:533px; left:854px; width:499px; height:60px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(33);\" style=\"top:601px; left:854px; width:499px; height:60px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(36);\" style=\"top:669px; left:854px; width:499px; height:81px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim.fromTo(cOf(\"2-title\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1);\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "TA BL E O F C O N T EN T S  12  Budget allocation  13  3  Message from the President of the Board Message from the Strategic Advisor to the Board  4  Shared values for lasting impact – Our approach at a glance  6  Cartier Philanthropy: Improving the lives of vulnerable communities Cartier Philanthropy – our global footprint  9  Cartier for Nature: Conserving & restoring ecosystems & biodiversity Cartier for Nature – our global footprint  Spotlight: notable results of Cartier Philanthropy and Cartier for Nature partners • Strengthening sustainable livelihoods • S upporting women and children to unlock their potential and thrive • Responding to humanitarian and climate emergencies • Conserving landscapes to protect panthers  22  Spotlight: Selected Stories from the Field • O disha’s Generous Forest: Helping indigenous women in rural India lift themselves out of poverty • F ire Country: Reviving Australia’s indigenous fire management for nature and climate  29  Cartier Philanthropy – our partners  33  Cartier for Nature – our partners  36  Governance Image credits  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 3-img-1\" style=\"top:30px;left:206px;\" src=\"/AR2024-25/static/_content/3-img-1.png\"/>\n        <img class=\"abs halfScaleC 3-img-1\" style=\"top:30px;left:908px;\" src=\"/AR2024-25/static/_content/3-img-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim.staggerFromTo(cOf(\"3-img-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.6, 1)\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n        }\n      ",
    "searchText": "MESSAGE FROM  MESSAGE FROM  THE PRESIDENT OF THE BOARD  THE STRATEGIC ADVISOR TO THE BOARD  Philanthropy is a natural extension of Cartier’s identity. It is a sincere expression of who we are, a Maison shaped by a legacy of generosity, curiosity, respect and an uncompromising pursuit of excellence. But it also speaks of something even more essential: our deep conviction that, in the face of adversity, we all stand together – actively, universally, consistently and with a constant focus on sustaining meaningful impact. Since the creation of Cartier Philanthropy in 2012 and the launch of Cartier for Nature in 2020, we have contributed towards improving lives and protecting biodiversity, choosing to act, to engage with humility and rigour, and to stand alongside those who restore, empower and inspire. This commitment stems from our belief that every human being, and every living ecosystem, holds within it the potential to flourish. But space, trust and time are required for that potential to unfold. Philanthropy is in this sense not only about alleviating suffering, but also creating the conditions for dignity, autonomy and resilience. We pursue this mission with the same standards we bring to everything we do: a sense of responsibility, a search for lasting value and a culture of excellence. We support partners who act with courage and compassion, who measure progress with integrity, and who continue to deliver transformative results despite the increasing complexity of today’s world. In a world marked by fragmentation and uncertainty, philanthropy reconnects us with nature, with one another, and with our shared humanity. It reminds us that we belong to a greater whole, and that every action we take has the power to shape the future.  This year’s Annual Report has a new format. It is a joint review that presents the work of Cartier Philanthropy – the Maison’s foundation dedicated to improving the lives of vulnerable communities – alongside that of Cartier for Nature, which supports the conservation and restoration of healthy ecosystems. We have chosen to highlight the impact of partners from both portfolios together to reflect the fact that poverty and environmental degradation are deeply intertwined and often create a vicious cycle where one exacerbates the other. Degraded environments – caused by global economic forces outside the control of the most vulnerable communities – can lead to reduced agricultural yields, water scarcity, and increased vulnerability to natural disasters, all of which negatively impact livelihoods and push people further into poverty. In turn, persistent poverty and a lack of access to economic opportunities can force people to rely on an unsustainable exploitation of their natural resources, which may further accelerate deforestation, soil erosion and biodiversity loss. The interconnectedness of global challenges is evident at the nexus of poverty and nature, but it is equally striking in areas such as health, education, gender and demography. Accordingly, our work and that of our partners is not siloed: the solutions that create the strongest positive impact are often those that take these different dimensions into account from the start. This joint Annual Report for Cartier Philanthropy and Cartier for Nature cannot possibly do justice to the work of all our nearly 90 partners. Instead, it aims to provide a snapshot of the breadth and impact of their efforts, and to highlight some of the most inspiring results they have achieved during the 12 months from April 2024 to March 2025. We hope it will also be a journey of discovery, especially if you have until now been more familiar with either Cartier Philanthropy or Cartier for Nature. Enjoy the read.  Cyrille Vigneron, Cartier Chairman of Culture and Philanthropy, President of the Board  Pascale de la Frégonnière, Strategic Advisor to the Board  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"abs halfScaleC 4-title\" style=\"top:474px;left:469px;\" src=\"/AR2024-25/static/_content/4-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.6, 1)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n        }      \n      ",
    "searchText": "SH AR ED VALU ES FO R LAST I NG I M PAC T – O U R APPR O AC H AT A GLANC E"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 5-text\" style=\"top:568px;left:201px;\" src=\"/AR2024-25/static/_content/5-subtext-1.png\"/>\n        <img class=\"abs halfScale 5-text\" style=\"top:636px;left:201px;\" src=\"/AR2024-25/static/_content/5-text-1.png\"/>\n        <img class=\"abs halfScale 5-text\" style=\"top:666px;left:201px;\" src=\"/AR2024-25/static/_content/5-text-2.png\"/>\n        <img class=\"abs halfScale 5-text\" style=\"top:695px;left:201px;\" src=\"/AR2024-25/static/_content/5-text-3.png\"/>\n        <img class=\"abs halfScale 5-text\" style=\"top:742px;left:201px;\" src=\"/AR2024-25/static/_content/5-text-4.png\"/>\n        <img class=\"abs halfScale 5-text\" style=\"top:772px;left:201px;\" src=\"/AR2024-25/static/_content/5-text-5.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n          pg5Anim.staggerFromTo(cOf(\"5-text\"), 0.6, {x: 30, opacity: 0}, {x:0, opacity: 1}, 0.35, 1)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n        }\n      ",
    "searchText": "C artier Philanthropy and C artier fo r Nature are fully funde d by C artier.  They are guided by core values shared with Cartier:  Respect for the communities they engage with Trust that shapes their relationships with partners Integrity t hat drives our commitment to accountability and continuous improvement  Compassion that pushes us to create a fairer world Ambition to support high-impact initiatives by results-oriented organisations  Cartier Philanthropy and Cartier for Nature both make grants to nonprofit organisations that develop and implement proven solutions to global challenges and create positive, verifiable change. Their investments allow to de-risk intervention models that can be replicated and scaled with governments or through a market approach. Cartier Philanthropy and Cartier for Nature provide their partners with long-term flexible funding to address complex problems  and build partnerships based on trust and a shared vision of outcomes. They also offer tailored expertise in monitoring and evaluation, behavioural change strategies, and branding, to strengthen their grantees’ capacity and maximise their impact. In addition to financial support, Cartier Philanthropy and Cartier for Nature offer their partner organisations opportunities to connect with other like-minded funders as well as enhanced visibility on their communication channels.  5"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 6-title\" style=\"top:282px;left:36px;\" src=\"/AR2024-25/static/_content/6-title-1.png\"/>\n        <img class=\"abs halfScale 6-title\" style=\"top:363px;left:36px;\" src=\"/AR2024-25/static/_content/6-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.staggerFromTo(cOf(\"6-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n        }\n      ",
    "searchText": "CARTIER PHILANTHROPY I M PROVI NG TH E L I VE S O F VULNER A B L E C OMMU NI T I E S"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n      \n        <img class=\"abs halfScaleC 7-logo\" style=\"top:84px;left:-59px;\" src=\"/AR2024-25/static/_content/7-logo.png\"/>\n        <img class=\"abs halfScaleC 7-logo\" style=\"top:249px;left:173px;\" src=\"/AR2024-25/static/_content/7-subtext.png\"/>\n        <img class=\"abs halfScale 7-text\" style=\"top:433px;left:366px;\" src=\"/AR2024-25/static/_content/7-text-1.png\"/>\n        <img class=\"abs halfScale 7-text\" style=\"top:567px;left:127px;\" src=\"/AR2024-25/static/_content/7-text-2.png\"/>\n        <img class=\"abs halfScale 7-text\" style=\"top:488px;left:895px;\" src=\"/AR2024-25/static/_content/7-text-3.png\"/>\n        <img class=\"abs halfScale 7-text\" style=\"top:618px;left:897px;\" src=\"/AR2024-25/static/_content/7-text-4.png\"/>\n        <img class=\"abs halfScale 7-text\" style=\"top:665px;left:897px;\" src=\"/AR2024-25/static/_content/7-text-5.png\"/>\n        <img class=\"abs halfScale 7-text\" style=\"top:713px;left:897px;\" src=\"/AR2024-25/static/_content/7-text-6.png\"/>\n        <img class=\"abs halfScale 7-text\" style=\"top:742px;left:897px;\" src=\"/AR2024-25/static/_content/7-text-7.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.staggerFromTo(cOf(\"7-logo\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.35, 1)\n            .staggerFromTo(cOf(\"7-text\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.35, 1.9)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();\n        }\n      ",
    "searchText": "W ith th e c r e a t i on of C a r t i e r P hi l a n t hr op y (or i g i n a l l y C a r t i e r C ha r i t a b l e Fou n d at i o n ) in Gene va i n 2 0 1 2 , C a r t i e r a d op t e d a st r a t e gi c a p pr oa c h t o phi l a n t hr opy, m a rke d by ambi t i on , p r ofe ssi on a l i sm , a n d a d e t e r m i n a t i on t o c r e a t e e n d u r i n g i m p a c t , echo ing t he Ma i son ’s foc u s on l on g-t e r m va l u e c r e a t i on .  VI S I O N Cartier Philanthropy believes in a world where everyone can realise their potential.  A REA S OF INTEREST M I S S I ON Cartier Philanthropy is committed to improving the lives of vulnerable communities across the world, with a particular focus on women and children. With the right support and access to new opportunities and choices, Cartier Philanthropy believes that those living in poverty can actively shape their own destinies and begin to thrive.  Cartier Philanthropy supports non-profits that address the multiple challenges of poverty across four key focus areas:  > Access to basic services (health care,  nutrition, education, water & sanitation)  > Women’s social and economic development  > Sustainable livelihoods > Emergency response  7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 8-title\" style=\"top:72px;left:86px;\" src=\"/AR2024-25/static/_content/8-title-1.png\"/>\n        <img class=\"abs halfScale 8-title\" style=\"top:103px;left:87px;\" src=\"/AR2024-25/static/_content/8-title-2.png\"/>\n\n        <img class=\"abs halfScaleC 8-text\" style=\"top:667px;left:10px;\" src=\"/AR2024-25/static/_content/8-sub-1.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:759px;left:-5px;\" src=\"/AR2024-25/static/_content/8-sub-2.png\"/>\n\n        <img class=\"abs halfScaleC 8-text\" style=\"top:362px;left:-38px;\" src=\"/AR2024-25/static/_content/8-text-1.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:432px;left:4px;\" src=\"/AR2024-25/static/_content/8-text-2.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:555px;left:117px;\" src=\"/AR2024-25/static/_content/8-text-3.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:314px;left:387px;\" src=\"/AR2024-25/static/_content/8-text-4.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:35px;left:515px;\" src=\"/AR2024-25/static/_content/8-text-5.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:-99px;left:714px;\" src=\"/AR2024-25/static/_content/8-text-6.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:498px;left:447px;\" src=\"/AR2024-25/static/_content/8-text-7.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:602px;left:454px;\" src=\"/AR2024-25/static/_content/8-text-8.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:419px;left:699px;\" src=\"/AR2024-25/static/_content/8-text-9.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:-116px;left:737px;\" src=\"/AR2024-25/static/_content/8-text-10.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:412px;left:894px;\" src=\"/AR2024-25/static/_content/8-text-11.png\"/>\n        <img class=\"abs halfScaleC 8-text\" style=\"top:600px;left:938px;\" src=\"/AR2024-25/static/_content/8-text-12.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.staggerFromTo(cOf(\"8-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n          .staggerFromTo(cOf(\"8-text\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.8)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n        }\n      ",
    "searchText": "SOUTH ASIA  CARTI ER P HI LA N T H R O P Y  NORTH AFRICA AND MIDDLE EAST Intelehealth The Luminos Fund World Food Programme  G LOB AL FO OTP R I N T EUROPE Women for Women International  Educate Girls Mobile Creches One Heart Worldwide VisionSpring Industree Foundation Kheyti Medair Intelehealth Noora Health Rocket Learning SaveLife Foundation  WEST AFRICA NORTHERN AMERICA  Imagine Worldwide Integrate Health The Luminos Fund Muso Saha Global Ubongo Ashesi University mothers2mothers MSI Reproductive Choices Our Legacy Foundation myAgro  CommonLit Community Health Workers Institute Harlem Children’s Zone StrongMinds  CENTRAL AMERICA AND THE CARIBBEAN Semilla Nueva SOIL Fonkoze  SOUTHEAST ASIA 1001fontaines ANAK-Tnk Baan Dek Foundation Proximity Designs Noora Health  CENTRAL AFRICA  SOUTH AMERICA Root Capital  Ubongo VillageReach Village Enterprise Médecins Sans Frontières  EAST AFRICA  GLOBAL Co-Impact Community Health Impact Coalition MiracleFeet Room to Read  CAPACITY-BUILDING FOR PARTNERS Appleseed, IDinsight, Mighty Ally  SOUTHERN AFRICA Ubongo mothers2mothers SmartStart  Development Media International European Institute for Cooperation and Development Food 4 Education Fresh Life Healthy Learners Kidogo The Luminos Fund Pivot Ubongo VillageReach WorldBeing  BOMA International Center for Research on Women mothers2mothers StrongMinds Ujamaa Africa Women for Women International BRAC International Development Enterprises One Acre Fund Village Enterprise World Bicycle Relief World Food Programme  8"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 9-title\" style=\"top:696px;left:86px;\" src=\"/AR2024-25/static/_content/9-title-1.png\"/>\n        <img class=\"abs halfScale 9-title\" style=\"top:737px;left:86px;\" src=\"/AR2024-25/static/_content/9-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim.staggerFromTo(cOf(\"9-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n        }\n      ",
    "searchText": "CAR T I E R FOR N ATU R E CON SE RVI N G & R E S TO R IN G ECOSY S T EMS & BIO D I V E RS IT Y"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 10-title\" style=\"top:87px;left:-40px;\" src=\"/AR2024-25/static/_content/10-title-1.png\"/>\n        <img class=\"abs halfScaleC 10-title\" style=\"top:155px;left:437px;\" src=\"/AR2024-25/static/_content/10-sub-1.png\"/>\n        <img class=\"abs halfScale 10-text\" style=\"top:312px;left:308px;\" src=\"/AR2024-25/static/_content/10-text-1.png\"/>\n        <img class=\"abs halfScale 10-text\" style=\"top:424px;left:454px;\" src=\"/AR2024-25/static/_content/10-text-2.png\"/>\n        <img class=\"abs halfScale 10-text\" style=\"top:536px;left:307px;\" src=\"/AR2024-25/static/_content/10-text-3.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim.staggerFromTo(cOf(\"10-title\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.35, 1)\n            .staggerFromTo(cOf(\"10-text\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.35, 1.9)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop();\n        }\n      ",
    "searchText": "C a r t i e r fou n d e d C a r t i e r for N a t u r e i n 2 0 2 0 t o c om pl e m e n t i t s p hi l a n t hr opi c a c t i on s.  VI S I O N Cartier for Nature’s vision is a thriving Earth that is an enduring source of life and inspiration for future generations.  MI S S I O N Cartier for Nature’s mission is to help conserve and restore biodiversity and healthy ecosystems for the benefit of nature and people.  A R EAS O F I N TEREST A primary focus of Cartier for Nature’s work is on forest biodiversity and the ecosystem services that forests offer the populations that depend on them, such as providing natural resources, water purification, flood control and nature-based recreation. Cartier for Nature also supports the conservation of other critical terrestrial, marine and freshwater ecosystems. Grant-making is centred on three core approaches to achieving conservation goals:  > Conserving and restoring ecosystems > E mbracing smart solutions to accelerate the impact of actions addressing the environmental crisis  > Responding to environmental emergencies  10"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 11-title\" style=\"top:72px;left:86px;\" src=\"/AR2024-25/static/_content/11-title-1.png\"/>\n        <img class=\"abs halfScale 11-title\" style=\"top:103px;left:87px;\" src=\"/AR2024-25/static/_content/11-title-2.png\"/>\n\n        <img class=\"abs halfScaleC 11-text\" style=\"top:751px;left:-14px;\" src=\"/AR2024-25/static/_content/11-sub-1.png\"/>\n\n        <img class=\"abs halfScaleC 11-text\" style=\"top:422px;left:260px;\" src=\"/AR2024-25/static/_content/11-text-1.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:487px;left:300px;\" src=\"/AR2024-25/static/_content/11-text-2.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:545px;left:182px;\" src=\"/AR2024-25/static/_content/11-text-3.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:277px;left:347px;\" src=\"/AR2024-25/static/_content/11-text-4.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:235px;left:388px;\" src=\"/AR2024-25/static/_content/11-text-5.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:165px;left:468px;\" src=\"/AR2024-25/static/_content/11-text-6.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:104px;left:533px;\" src=\"/AR2024-25/static/_content/11-text-7.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:25px;left:660px;\" src=\"/AR2024-25/static/_content/11-text-8.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:445px;left:411px;\" src=\"/AR2024-25/static/_content/11-text-9.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:512px;left:437px;\" src=\"/AR2024-25/static/_content/11-text-10.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:564px;left:400px;\" src=\"/AR2024-25/static/_content/11-text-11.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:599px;left:402px;\" src=\"/AR2024-25/static/_content/11-text-12.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:625px;left:498px;\" src=\"/AR2024-25/static/_content/11-text-13.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:610px;left:565px;\" src=\"/AR2024-25/static/_content/11-text-14.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:603px;left:662px;\" src=\"/AR2024-25/static/_content/11-text-15.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:638px;left:709px;\" src=\"/AR2024-25/static/_content/11-text-16.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:566px;left:730px;\" src=\"/AR2024-25/static/_content/11-text-17.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:34px;left:678px;\" src=\"/AR2024-25/static/_content/11-text-18.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:133px;left:812px;\" src=\"/AR2024-25/static/_content/11-text-19.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:214px;left:904px;\" src=\"/AR2024-25/static/_content/11-text-20.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:500px;left:953px;\" src=\"/AR2024-25/static/_content/11-text-21.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:562px;left:811px;\" src=\"/AR2024-25/static/_content/11-text-22.png\"/>\n        <img class=\"abs halfScaleC 11-text\" style=\"top:597px;left:807px;\" src=\"/AR2024-25/static/_content/11-text-23.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim.staggerFromTo(cOf(\"11-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n          .staggerFromTo(cOf(\"11-text\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.8)\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n        }\n      ",
    "searchText": "CARTI ER FOR NAT U R E  G LOB AL FO OTP R I N T LEBAN ON ı Al Shouf Cedar Society  ROMAN I A ı Rewilding Europe  ETHI OP I A ı ORDA Ethiopia C HI N A ı China Green Foundation  GRE E CE ı SPBT MON G OLI A ı Wildlife Conservation Society  SPA IN ı Rewilding Europe  MOROCCO ı Global Diversity Foundation  NICA RA GUA ı Fauna & Flora K E NYA ı Soralo C AMBOD I A ı  E CUA DOR ı Fundación  Jocotoco  Rising Phoenix TA NZA NIA ı Honeyguide  Foundation  SA Õ TOMÉ & PRÍNCIPE ı  C OMOROS ı Dahari  Birdlife International ZA MBIA  PER U ı Rainforest Trust  I N D ON ES I A ı Planet Indonesia   eace Parks Foundation P Panthera Comaco  MAD AG AS C AR ı Blue Ventures NA MIBIA ı IRDNC MOZAMBI QU E ı Gorongosa Restoration Project  G L O B A L ı Conservation Evidence  The Nature Investment Facility Mongabay  S OU TH AFRI C A ı Panthera  Abalobi  AU S TRALI A ı The Nature Conservancy  11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 12-title\" style=\"top:70px;left:89px;\" src=\"/AR2024-25/static/_content/12-title-1.png\"/>\n      <img class=\"abs halfScale 12-title\" style=\"top:103px;left:86px;\" src=\"/AR2024-25/static/_content/12-title-2.png\"/>\n\n      <img class=\"abs halfScaleC 12-logo\" style=\"top:106px;left:77px;\" src=\"/AR2024-25/static/_content/12-logo.png\"/>\n      <h1 id=\"12-no\" class=\"abs bcpReg 12-no\" style=\"top:316px;left:202px; font-size: 3.4em; font-weight: 300; color: #33405a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 147}' ></h1>\n      <img class=\"abs halfScaleC 12-subtext\" style=\"top:313px;left:216px;\" src=\"/AR2024-25/static/_content/12-subtext.png\"/>\n\n      <img class=\"abs halfScaleC 12-piechart\" style=\"top:376px;left:-59px;\" src=\"/AR2024-25/static/_content/12-text-1.png\"/>\n      <img class=\"abs halfScaleC 12-text\" style=\"top:415px;left:-38px;\" src=\"/AR2024-25/static/_content/12-text-2.png\"/>\n      <img class=\"abs halfScaleC 12-piechart\" style=\"top:344px;left:26px;\" src=\"/AR2024-25/static/_content/12-piechart-1.png\"/>\n\n      <img class=\"abs halfScaleC 12-logo\" style=\"top:189px;left:739px;\" src=\"/AR2024-25/static/_content/12-subtitle.png\"/>\n      <h1 id=\"12-no\" class=\"abs bcpReg 12-no\" style=\"top:316px;left:922px; font-size: 3.4em; font-weight: 300; color: #33405a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 23}' ></h1>\n      <img class=\"abs halfScaleC 12-subtext\" style=\"top:313px;left:918px;\" src=\"/AR2024-25/static/_content/12-subtext.png\"/>\n\n      <img class=\"abs halfScaleC 12-piechart\" style=\"top:376px;left:643px;\" src=\"/AR2024-25/static/_content/12-text-1.png\"/>\n      <img class=\"abs halfScaleC 12-text\" style=\"top:415px;left:666px;\" src=\"/AR2024-25/static/_content/12-text-5.png\"/>\n      <img class=\"abs halfScaleC 12-piechart\" style=\"top:344px;left:730px;\" src=\"/AR2024-25/static/_content/12-piechart-2.png\"/>\n\n      <img class=\"abs halfScaleC 12-text-last\" style=\"top:678px;left:28px;\" src=\"/AR2024-25/static/_content/12-text-3.png\"/>\n\n      <img class=\"abs halfScaleC 12-perc\" style=\"top:715px;left:45px;\" src=\"/AR2024-25/static/_content/12-no-1.png\"/>\n      <img class=\"abs halfScaleC 12-perc\" style=\"top:713px;left:226px;\" src=\"/AR2024-25/static/_content/12-no-2.png\"/>\n      <img class=\"abs halfScaleC 12-perc\" style=\"top:715px;left:343px;\" src=\"/AR2024-25/static/_content/12-no-3.png\"/>\n      <img class=\"abs halfScaleC 12-perc\" style=\"top:713px;left:444px;\" src=\"/AR2024-25/static/_content/12-no-4.png\"/>\n      <img class=\"abs halfScaleC 12-perc\" style=\"top:713px;left:497px;\" src=\"/AR2024-25/static/_content/12-no-5.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.staggerFromTo(cOf(\"12-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n          .fromTo(cOf(\"12-logo\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.7)\n          .fromTo(cOf(\"12-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no\")[0])}}, 2)\n          .fromTo(cOf(\"12-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no\")[1])}}, 2)\n          .fromTo(cOf(\"12-subtext\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 2)\n          .fromTo(cOf(\"12-piechart\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.6)\n          .fromTo(cOf(\"12-text\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 3)\n          .fromTo(cOf(\"12-text-last\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3.5)\n          .staggerFromTo(cOf(\"12-perc\"), 0.4, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.2, 3.8)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          resetNumbers(\"12-no\");\n        }\n      ",
    "searchText": "BU DGE T A L L O C ATIO N SIN CE I NCEP TI ON  147  23  million Swiss francs invested to date  Geographic distribution  million Swiss francs invested to date  Geographic distribution  51% Africa 10% Americas 23% Asia 4% Europe >1% Oceania 11% Global/Undefined  47% Africa 5% Americas 27% Asia 10% Europe 9% Oceania 2% Global/Undefined  By focus area  40%  Access to basic services  25%  Women’s empowerment  21%  Sustainable livelihoods  12%  12%  Emergency Capacity Building response for partners  12"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 13-title\" style=\"top:573px;left:765px;\" src=\"/AR2024-25/static/_content/13-title-1.png\"/>\n        <img class=\"abs halfScale 13-title\" style=\"top:613px;left:766px;\" src=\"/AR2024-25/static/_content/13-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.staggerFromTo(cOf(\"13-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop();\n        }\n      ",
    "searchText": "SPOT LI GH T N OTAB L E RES U LT S OF C ART IER PHIL AN T HRO PY AN D C ART IER FOR N AT U RE PART N ERS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"14-no\" class=\"abs bcpMed 14-no\" style=\"top:630px;left:1027px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 7680, \"comma\": true}' ></h1>\n        <h1 id=\"14-no\" class=\"abs bcpMed 14-no\" style=\"top:713px;left:1027px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 6.3, \"decimals\": 1, \"preppend\": \"US$\", \"append\": \" million\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(cOf(\"14-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"14-no\")[0])}}, 1)\n            .fromTo(cOf(\"14-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"14-no\")[1])}}, 1.1)\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          resetNumbers(\"14-no\");\n        }\n      ",
    "searchText": "STR EN G TH EN IN G SUSTAIN A BLE LIVE LIH OODS The long-term wellbeing of communities and their environment depends on people’s ability to make a sustainable living. In line with their respective missions, Cartier Philanthropy and Cartier for Nature support organisations that equip vulnerable populations with the skills and resources needed to engage in or expand activities such as sustainable farming or fishing, agroforestry, or small-scale enterprises. These efforts help improve livelihoods while protecting natural ecosystems.  Village Enterprise aims to end extreme poverty. Leveraging a proven poverty graduation approach, it helps economically disadvantaged people in rural areas of Eastern and Southern Africa build smallscale, profitable businesses - often the only option to make a living where employment opportunities are scarce. In 2024, Village Enterprise helped 45,000 first-time entrepreneurs launch 18,000 businesses.  60% of entrepreneur households continue to increase their consumption of food, other goods and services ﬁve years after their graduation programme ended.  In Rwanda, Village Enterprise has been working directly with the government to expand its impact to national scale. Under this partnership, Village Enterprise teams train government staff and community-based parasocial workers to implement its proven “poverty graduation” model independently. This approach helps the government to deliver a wider range of services to more people in a cost-effective way by leveraging existing human resources.  7,680 people  were able to participate in this expanded programme in Year 1, and the government has now allocated an additional  US$6.3 million to the four districts’ social protection budgets to help reach an additional 25,000 households.  14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"15-no\" class=\"abs bcpMed 15-no\" style=\"top:613px;left:681px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 335000, \"comma\": true}' ></h1>\n        <h1 id=\"15-no\" class=\"abs bcpMed 15-no\" style=\"top:594px;left:1093px; font-size: 1.2em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 80000, \"comma\": true}' ></h1>\n        <h1 id=\"15-no\" class=\"abs bcpMed 15-no\" style=\"top:595px;left:1252px; font-size: 1.2em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3000, \"comma\": true}' ></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.fromTo(cOf(\"15-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"15-no\")[0])}}, 1)\n            .fromTo(cOf(\"15-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"15-no\")[1])}}, 1.1)\n            .fromTo(cOf(\"15-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"15-no\")[2])}}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          resetNumbers(\"15-no\");\n        }\n      ",
    "searchText": "COMACO tackles similar challenges in Zambia’s Luangwa Valley, an important wildlife stronghold for leopards, lions, elephants and rhinos. Here, climate change and depleted soils result in increasingly volatile crop yields for small-holder farmers. Some farmers then resort to clearing forest to obtain new fertile ground or produce charcoal, and some are forced to poach wildlife. COMACO breaks this vicious cycle by offering these farmers an alternative path. It trains them in sustainable agricultural practices that restore soil health and produce higher yields, and assists them to set up cooperatives which bring access to more services. COMACO then purchases their crops at above market prices and turns them into higher-value products sold in supermarkets. This provides the farmers with a stable income and contributes to the model becoming self-sustaining. In return, the participating farmers agree to stop poaching and become stewards of their environment, protecting wildlife, forests and farmland.  Since inception of the programme, 1.5 million hectares of land have been set aside as community-protected forests. COMACO had registered more than  335,000 participating farmers  by the end of 2024, with four in ﬁve households complying with its conservation guidelines.  3 out of 4 have achieved food security.  80,000 snares and 3,000 ﬁrearms used to kill wildlife have been surrendered. More than  In 2024, despite severe drought conditions, COMACO was able to sustain earlier progress, supporting small-holder farmers with targeted interventions to enhance their resilience and adapt to the changing climate. These include winter cropping using residual moisture from agroforestry, the promotion of drought-tolerant crops, the adoption of conservation agriculture practices, and diversification into alternative livelihoods like beekeeping and poultry.  15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"16-no\" class=\"abs bcpMed 16-no\" style=\"top:563px;left:597px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 325}' ></h1>\n        <h1 id=\"16-no\" class=\"abs bcpMed 16-no\" style=\"top:626px;left:597px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 300000, \"comma\": true}' ></h1>\n        <h1 id=\"16-no\" class=\"abs bcpMed 16-no\" style=\"top:730px;left:597px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 30, \"append\": \"% drop\"}' ></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.fromTo(cOf(\"16-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[0])}}, 1)\n            .fromTo(cOf(\"16-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[1])}}, 1.1)\n            .fromTo(cOf(\"16-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[2])}}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n        }\n      ",
    "searchText": "SUPP OR T IN G WO ME N A N D CHI L D RE N TO UNLO C K THE IR P OT EN TI A L A N D T HRI V E Around the world, women and girls remain among the most vulnerable groups, with many facing persistent gender inequalities, prejudice, and legal barriers. Overcoming gender discrimination and fighting for all children’s rights to quality healthcare, education, water and sanitation require renewed efforts. Many Cartier Philanthropy partners help women and their children surmount these challenges and avail themselves of the services, skills, resources and agency they need to unlock the opportunities they deserve.  Integrate Health brings essential healthcare services to mothers and their children in remote parts of Togo and Guinea that otherwise offer limited access to care. It trains community health workers, nurses and midwives who are integrated into the public health system and helps improve and refurbish local health centres and clinics. In 2024, Integrate Health worked with  325  community health workers in Togo and Guinea to provide essential healthcare to over  300,000  patients.  In these communities, 90% of children are evaluated and treated within 24 hours. A study in Togo found that Integrate Health’s interventions contributed to a  30% drop  in the  mortality of children under ﬁve over a ﬁve-year period.  16"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n\n        <h1 id=\"17-no\" class=\"abs bcpMed 17-no\" style=\"top:638px;left:163px; font-size: 2.4em; font-weight: 300; color: #282441; padding: 0px; margin: 0px;\"  data-number='{\"to\": 150000, \"comma\": true}' ></h1>\n        <h1 id=\"17-no\" class=\"abs bcpMed 17-no\" style=\"top:638px;left:165px; font-size: 2.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 150000, \"comma\": true}' ></h1>\n        \n        <h1 id=\"17-no\" class=\"abs bcpMed 17-no\" style=\"top:673px;left:1117px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 370000, \"comma\": true}' ></h1>\n        <h1 id=\"17-no\" class=\"abs bcpMed 17-no\" style=\"top:752px;left:1131px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 70000, \"comma\": true}' ></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim.fromTo(cOf(\"17-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[0])}}, 1)\n            .fromTo(cOf(\"17-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[1])}}, 1)\n            .fromTo(cOf(\"17-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[2])}}, 1.1)\n            .fromTo(cOf(\"17-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[2])}}, 1.2)\n            .fromTo(cOf(\"17-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[3])}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop();\n          resetNumbers(\"17-no\");\n        }\n      ",
    "searchText": "In South Africa, SmartStart aims to provide access to quality early learning opportunities to all children, so that they meet developmental milestones for their age and are ready for school. It has trained and supports 18,000 women entrepreneurs operating quality, low-fee daycare centres in their communities, while working with the government to accredit these centres and subsidise children’s attendance.  The Luminos Fund runs accelerated learning programmes for out-of-school children in Ethiopia, Ghana, Liberia, the Gambia and Lebanon. It teaches them to read, write and count. In ten months, children catch up on foundational literacy and numeracy skills and successfully get into state schools. Luminos’ programme is based on the science of teaching, using a structured, play-based curriculum in local languages and monitoring attendance and progress of every learner. Learners don’t simply catch up with their peers – they outperform them in the long run and thrive upon integrating public school. In 2023, in Liberia, after completing the 10 month-programme, Luminos graduates read 29 words per minute, versus 19 words per minute for children enrolled in state school and 7 for children not in school.  Every day, 150,000 children attend a SmartStart franchise centre, where they receive a nutritious meal, play and learn. SmartStart centres use a playbased, structured curriculum to develop children’s curiosity and build the foundations for future learning.  Out of the 150,000 children attending SmartStart centres, 65% meet the physical, social, emotional and cognitive milestones expected for their age – signiﬁcantly higher than the national average of 45%.  In Ethiopia, where more than 5 million children are out of school, the Ministry of Education is now replicating the Luminos programme, with highly encouraging results – demonstrating the potential for Luminos’ solution to spread and scale.  To date, more than  370,000  children have beneﬁted from the Luminos programme -  70,000 of them in 2024 alone.  17"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RESP ON DIN G TO HU MA N I TA RI A N AND C LIM ATE E ME RG E N CI E S Effective and timely responses to humanitarian and climate emergencies can save lives, relieve suffering, protect livelihoods and restore critical ecosystems. Our emergency response funding aims to ensure that people’s immediate basic needs are met, that they can continue to live in dignity despite the challenges they face, and that the people and nature can rebuild and strengthen their resilience to climate impacts.  One Heart Worldwide works to decrease maternal and infant mortality in rural Nepal. It partners with local government and communities to upgrade health facilities with birthing equipment, and to train staff and community health workers to create a safer childbirth environment in remote areas. In September 2024, as heavy monsoon rains caused severe  One Heart Worldwide helped maintain access to critical health services for mothers and newborns in the rural Kavrepalanchok District. flooding and landslides across the country,  18"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"19-no\" class=\"abs bcpMed 19-no\" style=\"top:651px;left:141px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4500, \"comma\": true}' ></h1>\n        <h1 id=\"19-no\" class=\"abs bcpMed 19-no\" style=\"top:752px;left:133px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 13000, \"comma\": true}' ></h1>\n        <h1 id=\"19-no\" class=\"abs bcpMed 19-no\" style=\"top:198px;left:1059px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50000, \"comma\": true}' ></h1>\n        <h1 id=\"19-no\" class=\"abs bcpMed 19-no\" style=\"top:258px;left:1060px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 115, \"append\": \" hectares\"}' ></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.fromTo(cOf(\"19-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[0])}}, 1)\n            .fromTo(cOf(\"19-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[1])}}, 1.1)\n            .fromTo(cOf(\"19-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[2])}}, 1.2)\n            .fromTo(cOf(\"19-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[3])}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop();\n          resetNumbers(\"19-no\");\n        }\n      ",
    "searchText": "Médecins Sans Frontières (MSF), also known as Doctors Without Borders, is an international humanitarian association dedicated to providing medical assistance to populations facing threats to their lives or health. The conflict in Sudan, which broke out in April 2023, has resulted in the displacement of over 12.4 million people. Of these, more than 3.3 million have sought refuge in neighbouring countries. Chad alone is hosting over 750,000 Sudanese refugees, many of whom lack essential services such as healthcare, food, shelter, water and sanitation.  Following the massive wildfires that ravaged Greece in 2023, Cartier for Nature has been supporting the efforts of the Society for Biodiversity Protection of Thrace (SPBT) to restore key wildlife habitats in the heavily damaged Dadia National Park, one of Europe’s most critical refuges for rare raptor species.  In 2024, SPBT planted almost  50,000  native trees  to restore  115 hectares of burnt forest in the heart of the park.  MSF teams are working in two large refugee settlements in Chad, in Adré and Aboutengué, to address these immense needs, providing primary healthcare, routine vaccinations and non-food items.  In 2 024, MSF doctors and nurses provided consultations in its clinics in both locations for around  4,500  patients per week, attended more than 1,000 births, and vaccinated over  13,000 children.  19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"20-no\" class=\"abs bcpMed 20-no\" style=\"top:382px;left:571px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 95, \"append\": \"%\"}' ></h1>\n        <h1 id=\"20-no\" class=\"abs bcpMed 20-no\" style=\"top:427px;left:566px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 79, \"append\": \"%\", \"preppend\": \"up from \"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.fromTo(cOf(\"20-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[0])}}, 1)\n            .fromTo(cOf(\"20-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[1])}}, 1.1)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          resetNumbers(\"20-no\");\n        }\n      ",
    "searchText": "CONS ER VIN G LA N D S CA P E S TO P ROTEC T PA NT HERS There are five “panther” species in the world. Members of the genus Panthera, they’re more commonly known as the Big Cats: lions, tigers, leopards, snow leopards and jaguars. Reflecting Cartier’s special connection with its iconic panthère, many Cartier for Nature partners around the world are conserving big cat populations and their habitats – from the jungles of South America, where the mighty jaguar roams, to the high mountain plateaus of Central Asia, the realm of the elusive snow leopard.  In Zambia, Panthera’s “Furs for Life” programme fosters change by supporting traditional and religious communities to use synthetic alternatives to leopard fur in their special events and ceremonies. One such event is the annual Kuomboka festival in which the Lozi People of western Zambia traditionally wear leopard and serval skin skirts together with lion mane head gear as they paddle their Litunga (King) and Queens in ceremonial barges on the Barotse River flood plains.  The Peace Parks Foundation fosters coexistence between people and predators to address another key threat to Zambia’s leopard population: retaliation killings due to human-wildlife conflicts. In the Simalaha Conservancy, the organisation has worked with pastoral communities in Sikaunzwe and Kukulwani villages to construct predator-proof overnight livestock holding pens (called “bomas”). It also helped train and hire professional herders that take care of the animals out in the pasture.  ZERO  As a result, livestock predation incidents were reported in these communities in 2024, and no retaliation killings of leopards or other predators were recorded.  95% up from 79%  In 2024, of the Kuomboka paddlers used Panthera’s synthetic “Heritage Furs”. This was in 2022, continuing the successful trend established since the Lozi partnered with “Furs for Life” in 2018. Panthera reports that leopard densities have more than doubled from their 2018 levels in Zambia’s Kafue National Park and surrounding areas, a frequently-cited source of leopard fur.  20"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"21-no\" class=\"abs bcpMed 21-no\" style=\"top:296px;left:895px; font-size: 2.4em; font-weight: 300; color: #273b7f; padding: 0px; margin: 0px;\"  data-number='{\"to\": 400, \"append\": \" camera\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(cOf(\"21-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[0])}}, 1)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          resetNumbers(\"21-no\");\n        }\n      ",
    "searchText": "In Ecuador, Fundación Jocotoco is making vital contributions to the survival of threatened species through a network of privately-run nature reserves that connect key habitats in five critical biodiversity hotspots. In 2024, Jocotoco added 2,000 hectares of natural habitat to its conservation network, taking the total area under its direct management to 43,000 hectares or 430 sq. km. In the Canandé reserve in the Chocó region, Jocotoco recently carried out a wildlife monitoring study using camera traps. It revealed that Canandé is home to at least 11 jaguars — 8 females and 3 males, mostly adults. This is one of the highest densities of these big cats in the entire Chocó region. It’s a sign of hope for a species that is increasingly being pushed to the brink across the continent.  In China, Cartier for Nature is supporting the efforts of the China Green Foundation and government partners to monitor and conserve snow leopards in the Three-River-Source National Park, one of this species’ most important strongholds anywhere in the world. Thanks to local community rangers, more than  400 camera  traps covering over 9,000 sq. km of snow leopard habitat have been deployed since 2022, capturing more than 50,000 images of wildlife. These include nearly 7,000 snow leopard images that provide valuable insights into their population status as well as mating, hunting and feeding behaviour.  21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 22-title\" style=\"top:269px;left:107px;\" src=\"/AR2024-25/static/_content/22-title-1.png\"/>\n        <img class=\"abs halfScale 22-title\" style=\"top:309px;left:108px;\" src=\"/AR2024-25/static/_content/22-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.staggerFromTo(cOf(\"22-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n        }\n      ",
    "searchText": "SPOT LI G H T SE LE CT E D S TO R I E S FR O M T H E F IE L D"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 23-title\" style=\"top:617px;left:634px;\" src=\"/AR2024-25/static/_content/23-title-1.png\"/>\n        <img class=\"abs halfScale 23-title\" style=\"top:705px;left:634px;\" src=\"/AR2024-25/static/_content/23-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim.staggerFromTo(cOf(\"23-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n        }\n      ",
    "searchText": "O DI S HA ’ S GENERO US FO RES T: HELP I NG I NDI GENO US W O MEN I N RURA L I NDI A LI FT T HEMS ELVES O UT O F P O VERTY Indigenous communities in India’s Odisha state have relied on Sal leaves for generations. The Industree Foundation is helping them build profitable small-scale leaf plate production units to secure more stable livelihoods. 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 24-text\" style=\"top:69px;left:589px;\" src=\"/AR2024-25/static/_content/24-text-1.png\"/>\n        <img class=\"abs halfScale 24-quote\" style=\"top:426px;left:448px;\" src=\"/AR2024-25/static/_content/24-quote-1.png\"/>\n        <img class=\"abs halfScale 24-quote\" style=\"top:523px;left:449px;\" src=\"/AR2024-25/static/_content/24-quote-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(cOf(\"24-text\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .staggerFromTo(cOf(\"24-quote\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1.35)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n        }\n      ",
    "searchText": "Industree Foundation  T h e r e’s a p op u lar s aying in U ttar akh and that go es  “Sal, sau saal khada, sau saal padaa, sau saal sadaa,” wh ich m e ans  “A Sal tree grows for 100 years, stays on the forest floor for 100 years, and rots for 100 years”. The Sal tree (scientific name Shorea robusta) is a timeless symbol of India. Growing in dense forests, Sal has woven itself into the fabric of India’s culture and economy for centuries. Revered in religious texts, the tree is synonymous with enlightenment. Beyond their spiritual significance and medicinal value, Sal leaves are also a vital source of income for indigenous communities, such as those in the country’s eastern Odisha State. There, forest-dwellers have long collected fallen  leaves in nearby forests to make prasadam (religious offerings of food) or cups and leaf plates known as patravali, or to sell them to local middlemen with minimal added value. Although demand for these eco-friendly handicrafts is growing, rural artisans remain largely unorganised, with little access to working capital and production infrastructure. This has limited their ability to secure a steady, sufficient income for themselves and their families.  The Industree Foundation is an Indian NGO working to transform the situation in two districts of Odisha State – Kandhamal and Koraput – where the main economic activities are agriculture, horticulture, livestock and forest products. Engaging with tribal groups that are actively involved in leaf collection, Industree is helping them set up two womenowned production units to make leaf plates, an eco-friendly alternative to disposable plastic products.  24"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 25-box\" style=\"top:322px;left:644px;\" src=\"/AR2024-25/static/_content/25-box-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim.fromTo(cOf(\"25-box\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop();\n        }\n      ",
    "searchText": "A Cartier Philanthropy partner since 2023, I n dus t r ee b eg a n it s w or k i n 2 01 7 w it h w om en fr om t h e Kon d h t r ib e.  “The Khond are traditionally hunter-gatherers who practice agriculture in forest areas,” says Suresh Chandran, Industree’s Senior Manager of NTFP Operations. “Despite the rich natural environment, Kondh communities struggle with intergenerational poverty, having very limited access to schools, health, nutrition, formal employment and land ownership. Kondh women have long crafted disposable serving ware from Sal leaves but earned as little as 2,000 to 3,000 rupees per year (between $20 and $35) due to challenges like difficulty to meet quality standard, limited market access and exploitation by intermediaries. Despite their persistent hard work, they struggled to generate sufficient income to escape poverty.” Industree has since scaled its operations across Odisha and works with several tribal communities today, including the Bhumia, Gadaba, Paraja and Durua. Playing the combined role of incubator and accelerator, Industree makes it easier for marginalised women to join together and assists them to develop sustainably sourced plates and bowls that appeal to modern markets. It helps them to streamline their operations and ensures the production units have access to vital working capital and consistent demand.  As a result of these efforts, nearly 3 in 4 women producers who work with Industree have increased and regularised their income. They now earn an average of 33% more.  “We deliver comprehensive training that equips indigenous women with the expertise to identify quality leaves, adopt efficient collection practices and increase productivity,” says Suresh. “We also provide them with opportunities to learn vital technical skills, such as fine stitching, line production and quality control. Critical modules include soft skills building to help them strengthen their self-assurance in decision making at home, in their communities and in their workplaces. Our goal is to ensure participants are equipped to work effectively and make steady progress by, for instance, moving toward supervisory and leadership roles.  “We also partner with designers to co-create a range of market-driven products, including innovative tableware and lifestyle items such as buffet plates. By forging strong market linkages with large hubs like Bengaluru, we are gradually expanding the opportunities for these communities, enabling them to move beyond local sales. “In addition, we have now secured essential certifications, including Food Grade Certification, to open international market opportunities. “Women who are socially and economically empowered to contribute to their own profitable businesses and to the resilience of their communities: that’s what success looks like for us as part of a broader vision of eco-conscious development in Odisha”, says Suresh. Indeed, 70% of the women artisans working with Industree report that this is their first job outside the home, and thus contributes to their financial independence as well as giving them a powerful voice in their households and communities.  25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 26-title\" style=\"top:652px;left:635px;\" src=\"/AR2024-25/static/_content/26-title-1.png\"/>\n        <img class=\"abs halfScale 26-title\" style=\"top:738px;left:633px;\" src=\"/AR2024-25/static/_content/26-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.staggerFromTo(cOf(\"26-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n        }\n      ",
    "searchText": "FI RE C O UNT RY: REVI VI NG A US T RA LI A ’ S I NDI GENO US FI RE MA NA GEMENT FO R NAT URE A ND C LI MATE Across Australia, indigenous peoples have formed a unique relationship with their environment that has remained unbroken for millennia. To many of them, people and country are one. 26"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 27-text\" style=\"top:17px;left:586px;\" src=\"/AR2024-25/static/_content/27-text-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.fromTo(cOf(\"27-text\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop();\n        }\n      ",
    "searchText": "The Nature Conservancy  T h e N g arinyin peo ple have b een cus t o d ians o f W ilinggin Co untry, in th e f ar no rt hern reaches o f Wes t ern A us t ralia, s ince time immemo ri a l . T h is land s cape is wo ven t ight ly int o their cult ural fab ric, and t hey i n tu r n h ave no t jus t managed t heir land , b ut s haped it – with fire. “Fire is very important for Wilinggin Country. In my language, we call it Wudu. The old people who travelled across this land knew what to do. They carried fire sticks with them, in their hair or in a Coolaman”, says Donald Campbell, the senior Ngarinyin elder. He recounts how during the cooler months at the end of each wet season, his ancestors would set small, controlled fires as they went about their day, burning grass and small bushes to create openings in the landscape and allow the soil to rejuvenate. These fires would burn at low temperatures, doing no damage to the iconic, bottle-shaped boabs  or other larger trees and bushes – but burning off enough flammable material to prevent larger, hotter and much more destructive fires from engulfing the landscape later in the dry season. Over the course of many centuries, plant and animal species in Wilinggin Country adapted to this land management of fighting fire with fire. Many species came to rely on controlled seasonal burns to clear new habitats for them to colonise or to feed in. With the arrival of the first colonisers in Australia in the late 18th century, this finely-tuned  27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 28-box\" style=\"top:335px;left:295px;\" src=\"/AR2024-25/static/_content/28-box-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.fromTo(cOf(\"28-box\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n        }\n      ",
    "searchText": "ecological balance was upended. Over the course of two centuries, indigenous people were increasingly forced off the land, resulting in a profound shift in how fire was managed. With the disappearance of traditional controlled burns in most of Australia, dry grass was able to build up each year and provide fuel for larger, much hotter bushfires – often resulting in the catastrophic conflagrations we have become all too used to witnessing across the continent.  “I’ve seen some terrible fire events and I’ve seen what happens with good fire management that prevents them,” he says. “If we do no burning just after the wet season, by the time the end of the drier season comes, one little ignition of a lightning strike or a wayward campfire will all of a sudden take out huge sections of country. But now that we do our early burning in a strategic way, those larger fires don’t take out as big an area and therefore we release less carbon annually.”  However, important changes are once again underway down under.  Today, TNC works with 42 indigenous communities across Northern Australia, all of which run controlled burning programmes. This includes technical assistance to help communities and representative bodies develop Healthy Country Plans, which define land management objectives together with social and cultural values. Controlled burning combines ancient indigenous knowledge with new insights from fire science as well as the latest technology, such as remote sensing using satellite imagery.  “Today, we are in the middle of another shift, but this time it is a shift back towards the old ways, back towards an indigenous approach to land management and especially to fire”, says Luke Preece, Specialist for Indigenous Landscapes at The Nature Conservancy (TNC) Australia, a Cartier for Nature partner. In the early 1990s, the decades-long struggle of Australian Indigenous Peoples for land rights resulted in the granting of so-called Native Titles to indigenous organisations by the government. Since then, many initiatives have emerged to revive traditional indigenous fire management methods, with significant benefits for people, climate and nature. One such initiative is led by the Wilinggin Aboriginal Corporation (WAC), which holds the Native Title for Wilinggin Country and represents the interests of the Ngarinyin people. Luke Russ is a Fire Manager for the WAC. In this role, he works with Traditional Owners to plan and manage controlled burns in the landscape.  Together, these programmes have helped avoid more than a million tonnes of CO2 emissions annually. Ten communities are currently able to translate this work into carbon credits, generating an estimated income of AUD $60 million per year, which funds the management of 23 million hectares of land.  28"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 29-title\" style=\"top:447px;left:132px;\" src=\"/AR2024-25/static/_content/29-title-1.png\"/>\n        <img class=\"abs halfScale 29-title\" style=\"top:530px;left:132px;\" src=\"/AR2024-25/static/_content/29-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.staggerFromTo(cOf(\"29-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n        }\n      ",
    "searchText": "C AR T I E R P HI LAN T H R O PY O U R PA R TN E R S"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 30-text\" style=\"top:7px;left:-34px;\" src=\"/AR2024-25/static/_content/30-text-1.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:157px;left:-34px;\" src=\"/AR2024-25/static/_content/30-text-2.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:15px;left:295px;\" src=\"/AR2024-25/static/_content/30-text-3.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:258px;left:-34px;\" src=\"/AR2024-25/static/_content/30-text-4.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:145px;left:295px;\" src=\"/AR2024-25/static/_content/30-text-5.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:15px;left:628px;\" src=\"/AR2024-25/static/_content/30-text-6.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:395px;left:-34px;\" src=\"/AR2024-25/static/_content/30-text-7.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:256px;left:296px;\" src=\"/AR2024-25/static/_content/30-text-8.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:143px;left:628px;\" src=\"/AR2024-25/static/_content/30-text-9.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:12px;left:959px;\" src=\"/AR2024-25/static/_content/30-text-10.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:550px;left:-34px;\" src=\"/AR2024-25/static/_content/30-text-11.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:376px;left:296px;\" src=\"/AR2024-25/static/_content/30-text-12.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:267px;left:628px;\" src=\"/AR2024-25/static/_content/30-text-13.png\"/>\n\n        <img class=\"abs halfScaleC 30-text\" style=\"top:487px;left:296px;\" src=\"/AR2024-25/static/_content/30-text-15.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:382px;left:628px;\" src=\"/AR2024-25/static/_content/30-text-16.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:193px;left:958px;\" src=\"/AR2024-25/static/_content/30-text-17.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:618px;left:297px;\" src=\"/AR2024-25/static/_content/30-text-18.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:516px;left:628px;\" src=\"/AR2024-25/static/_content/30-text-19.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:288px;left:960px;\" src=\"/AR2024-25/static/_content/30-text-20.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:617px;left:629px;\" src=\"/AR2024-25/static/_content/30-text-21.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:426px;left:959px;\" src=\"/AR2024-25/static/_content/30-text-22.png\"/>\n        <img class=\"abs halfScaleC 30-text\" style=\"top:527px;left:959px;\" src=\"/AR2024-25/static/_content/30-text-23.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-text\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1)\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n        }\n      ",
    "searchText": "Producing clean and affordable drinking water for underserved communities through innovative social business models CAMBODIA, MADAGASCAR  Supporting women in dryland pastoral communities to start micro businesses in small groups through a poverty graduation approach  Development Media International  ETHIOPIA  TANZANIA  Promoting health-seeking behaviour in remote communities through engaging TV, radio and digital mass-media campaigns  Training teachers to provide essential health services to Zambian state school students ZAMBIA  Meeting the basic shelter, education, nutrition and health needs of Manila’s street children  Providing households with a path out of extreme poverty following a poverty graduation approach TANZANIA  PHILIPPINES  Mobilising rural communities to ensure all girls have access to quality education and learn INDIA  Providing non-profits with monitoring and evaluation support to improve their social impact GLOBAL  Harnessing behavioural insights to maximise the efficiency of social and environmental programmes  Setting-up and managing pooled funds to advance gender equality and women’s leadership GLOBAL  Providing households with a path out of extreme poverty through a contextadjusted poverty graduation approach HAITI  GLOBAL  Improving learners’ literacy and critical thinking in under-resourced middle and high schools using high-quality instructional materials UNITED STATES  GHANA  THAILAND  Providing affordable, nutritious meals to improve children’s attendance and learning in state schools  Addressing learning poverty through tech enabled, self-paced learning on tablets for primary school children SIERRA LEONE  Making salaried, skilled, supervised, and supplied community health workers the norm worldwide GLOBAL  Improving the wellbeing of children and migrant worker families in construction site camps  LEBANON, MADAGASCAR  KENYA  Providing scholarships for women from under-privileged background to become the African leaders of tomorrow  Nurturing adolescents’ personal development and learning potential for them to succeed in life  Training community health workers to address social as well as medical needs in underserved communities UNITED STATES  Designing, installing and servicing affordable, clean off-grid toilets in dense informal urban settlements KENYA, ZAMBIA  Supporting women eco-artisans from tribal communities to set-up craft cooperatives to improve their livelihoods INDIA  Breaking the poverty cycle by building up opportunities for all to thrive in school, work, health and life UNITED STATES  30"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 31-text\" style=\"top:4px;left:-35px;\" src=\"/AR2024-25/static/_content/31-text-1.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:156px;left:-34px;\" src=\"/AR2024-25/static/_content/31-text-2.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:10px;left:296px;\" src=\"/AR2024-25/static/_content/31-text-3.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:297px;left:-34px;\" src=\"/AR2024-25/static/_content/31-text-4.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:142px;left:296px;\" src=\"/AR2024-25/static/_content/31-text-5.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:21px;left:628px;\" src=\"/AR2024-25/static/_content/31-text-6.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:400px;left:-34px;\" src=\"/AR2024-25/static/_content/31-text-7.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:297px;left:296px;\" src=\"/AR2024-25/static/_content/31-text-8.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:116px;left:628px;\" src=\"/AR2024-25/static/_content/31-text-9.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:5px;left:959px;\" src=\"/AR2024-25/static/_content/31-text-10.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:566px;left:-34px;\" src=\"/AR2024-25/static/_content/31-text-11.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:389px;left:297px;\" src=\"/AR2024-25/static/_content/31-text-12.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:492px;left:298px;\" src=\"/AR2024-25/static/_content/31-text-13.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:273px;left:628px;\" src=\"/AR2024-25/static/_content/31-text-14.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:169px;left:960px;\" src=\"/AR2024-25/static/_content/31-text-15.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:599px;left:295px;\" src=\"/AR2024-25/static/_content/31-text-16.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:405px;left:628px;\" src=\"/AR2024-25/static/_content/31-text-17.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:259px;left:959px;\" src=\"/AR2024-25/static/_content/31-text-18.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:531px;left:629px;\" src=\"/AR2024-25/static/_content/31-text-19.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:410px;left:959px;\" src=\"/AR2024-25/static/_content/31-text-20.png\"/>\n        <img class=\"abs halfScaleC 31-text\" style=\"top:527px;left:959px;\" src=\"/AR2024-25/static/_content/31-text-21.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim.staggerFromTo(cOf(\"31-text\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1)\n        }\n\n        function onPageLeave() {\n          pg31Anim.stop();\n        }\n      ",
    "searchText": "Improving health outcomes and saving lives by strengthening primary healthcare systems in rural areas GUINEA, TOGO  Connecting community health workers with medical specialists through telemedicine to better serve rural patients’ health needs INDIA, CENTRAL ASIA  Building a network of quality, low-fee creches for children under three, run by women micro-entrepreneurs in urban informal settlements  Giving out-of-school children a second chance to learn and continue their education in state schools ETHIOPIA, GAMBIA, GHANA, LEBANON, LIBERIA  GLOBAL  GLOBAL  International Development Enterprises  Recruiting and training farm business entrepreneurs to provide bring smallholder farmers access to quality inputs and services for small-holder farmers for improved livelihoods ZAMBIA  INDIA  BANGLADESH, INDONESIA, INDIA, NEPAL  KENYA  Providing essential health care in humanitarian crises Producing and disseminating research to advance women’s equality and empowerment  Offering quality daycare and meals for migrant workers’ children  Equipping family care-givers with the knowhow to support hospitalised loved ones upon their return home and reduce re-admission  Employing women living with HIV as community health workers who deliver integrated primary healthcare services SOUTHERN AFRICA  Providing free access to quality sexual and reproductive health services for girls and women  Supplying affordable input packages - improved seeds and fertilisers - and trainings to help smallholder farmers increase yields RWANDA  Saving the lives of mothers and newborns by training medical staff and upgrading health facilities with birth centres  SENEGAL  NEPAL  Reducing child mortality through proactive home visits from community health workers and faster access to health centres  Advancing women small-holder farmers’ economic inclusion  Providing essential health care in humanitarian crises GLOBAL  Helping non-profits develop their brands to optimise their fundraising  SENEGAL  CÔTE D’IVOIRE, MALI  GLOBAL  Designing and selling affordable greenhouses backed by agronomic advisory support to improve small-holder farmers’ incomes and resilience to climate change INDIA  Providing nonsurgical clubfoot treatment for children in low and middle-income countries GLOBAL  Providing affordable layaway packages of improved seeds and fertilizers as well as poultry for small-holder farmers to increase their incomes  Providing essential healthcare and supporting patients through a continuum of care in partnership with the Ministry of Health MADAGASCAR  SENEGAL  31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 32-text\" style=\"top:-13px;left:-35px;\" src=\"/AR2024-25/static/_content/32-text-1.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:181px;left:-35px;\" src=\"/AR2024-25/static/_content/32-text-2.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:7px;left:297px;\" src=\"/AR2024-25/static/_content/32-text-3.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:325px;left:-35px;\" src=\"/AR2024-25/static/_content/32-text-4.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:149px;left:296px;\" src=\"/AR2024-25/static/_content/32-text-5.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:19px;left:628px;\" src=\"/AR2024-25/static/_content/32-text-6.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:522px;left:-35px;\" src=\"/AR2024-25/static/_content/32-text-7.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:289px;left:296px;\" src=\"/AR2024-25/static/_content/32-text-8.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:139px;left:628px;\" src=\"/AR2024-25/static/_content/32-text-9.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:8px;left:959px;\" src=\"/AR2024-25/static/_content/32-text-10.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:426px;left:296px;\" src=\"/AR2024-25/static/_content/32-text-11.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:234px;left:628px;\" src=\"/AR2024-25/static/_content/32-text-12.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:158px;left:958px;\" src=\"/AR2024-25/static/_content/32-text-13.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:566px;left:294px;\" src=\"/AR2024-25/static/_content/32-text-14.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:368px;left:628px;\" src=\"/AR2024-25/static/_content/32-text-15.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:269px;left:958px;\" src=\"/AR2024-25/static/_content/32-text-16.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:519px;left:627px;\" src=\"/AR2024-25/static/_content/32-text-17.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:386px;left:959px;\" src=\"/AR2024-25/static/_content/32-text-18.png\"/>\n        <img class=\"abs halfScaleC 32-text\" style=\"top:537px;left:958px;\" src=\"/AR2024-25/static/_content/32-text-19.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.staggerFromTo(cOf(\"32-text\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1)\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n        }\n      ",
    "searchText": "Proximity Designs  Designing and selling innovative agricultural products and services to help small-holder farmers increase their productivity and income  Providing affordable, safe drinking water in rural Ghana using a last-mile water utility model  Reducing road fatalities by providing state administrations with hands-on technical assistance on road safety and emergency trauma care  Producing and distributing affordable drought-resistant, biofortified maize seeds to small-holder farmers to address stunting and improve yields GUATEMALA  GLOBAL  Providing loans and advisory services to rural agri-businesses to improve smallholder farmers’ incomes and help develop the resilience of rural communities  Providing vision tests by trained nonmedical staff and selling affordable reading glasses to increase the quality of life and earning potential of low income-workers BANGLADESH  Developing and broadcasting culturally relevant TV and radio edutainment to support children’s learning WEST, EAST AND SOUTHERN AFRICA  Helping marginalised women in postconflict countries develop agency, improve wellbeing and build livelihoods KOSOVO, RWANDA  INDIA  INDIA  Implementing literacy programmes that cultivate the joy of reading and girl empowerment programmes that foster gender equity  UGANDA, ZAMBIA, KENYA, UNITED STATES  GHANA  MYANMAR  Leveraging the world’s largest state daycare network by using AI-powered, play-based content and in-person coaching to ensure children achieve their development milestones  Providing access to mental healthcare through group therapy for people affected by depression  Building a network of affordable daycare centres run by women micro-entrepreneurs to provide quality early learning opportunities for children under six  Empowering girls and boys to end genderbased violence through a programme delivered by state school teachers MALAWI  Providing in-school sessions to build social and emotional skills and improve the wellbeing of lower secondary school students RWANDA  Improving women’s livelihoods through a poverty graduation programme that involves setting up micro-businesses and savings groups DR CONGO, ETHIOPIA, KENYA, MOZAMBIQUE, RWANDA, UGANDA  Designing and delivering heavy-duty bicycles for rural students, community healthcare workers and farmers to improve school attendance, healthcare and market access  Deploying drones to overcome critical drug shortages and provide lab testing access in remote communities  Responding to hunger crises with food and cash assistance  DR CONGO, MALAWI, MOZAMBIQUE  GLOBAL  ZAMBIA  SOUTH AFRICA  PERU  Providing safe container-based toilets and waste collection for under-served urban communities HAITI  32"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 33-title\" style=\"top:377px;left:294px;\" src=\"/AR2024-25/static/_content/33-title-1.png\"/>\n        <img class=\"abs halfScale 33-title\" style=\"top:416px;left:294px;\" src=\"/AR2024-25/static/_content/33-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n          pg33Anim.staggerFromTo(cOf(\"33-title\"), 0.6, {x: 20, opacity: 0}, {x:0, opacity: 1}, 0.4, 1)\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop();\n        }\n      ",
    "searchText": "C A R TI ER FOR NAT U R E O UR PA R TN E R S"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 34-text\" style=\"top:52px;left:-34px;\" src=\"/AR2024-25/static/_content/34-text-1.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:145px;left:-35px;\" src=\"/AR2024-25/static/_content/34-text-2.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:46px;left:297px;\" src=\"/AR2024-25/static/_content/34-text-3.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:327px;left:-35px;\" src=\"/AR2024-25/static/_content/34-text-4.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:181px;left:296px;\" src=\"/AR2024-25/static/_content/34-text-5.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:16px;left:628px;\" src=\"/AR2024-25/static/_content/34-text-6.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:487px;left:-35px;\" src=\"/AR2024-25/static/_content/34-text-7.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:305px;left:296px;\" src=\"/AR2024-25/static/_content/34-text-8.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:57px;left:958px;\" src=\"/AR2024-25/static/_content/34-text-9.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:599px;left:-35px;\" src=\"/AR2024-25/static/_content/34-text-10.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:426px;left:296px;\" src=\"/AR2024-25/static/_content/34-text-11.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:221px;left:628px;\" src=\"/AR2024-25/static/_content/34-text-12.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:144px;left:958px;\" src=\"/AR2024-25/static/_content/34-text-13.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:543px;left:297px;\" src=\"/AR2024-25/static/_content/34-text-14.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:417px;left:628px;\" src=\"/AR2024-25/static/_content/34-text-15.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:302px;left:958px;\" src=\"/AR2024-25/static/_content/34-text-16.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:507px;left:627px;\" src=\"/AR2024-25/static/_content/34-text-17.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:464px;left:959px;\" src=\"/AR2024-25/static/_content/34-text-18.png\"/>\n        <img class=\"abs halfScaleC 34-text\" style=\"top:571px;left:958px;\" src=\"/AR2024-25/static/_content/34-text-19.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.staggerFromTo(cOf(\"34-text\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n        }\n      ",
    "searchText": "Equipping small-scale fishers to fish sustainably and sell at a premium on markets which value traceability SOUTH AFRICA  Al Shouf Cedar Society  Assisting farmers to conserve a fragile ecosystem, increase their income and reduce the risk of forest fires  Supporting wildlife conservation by empowering small farmers and ex-poachers with farming practices that restore soil health and boost production ZAMBIA  Summarising scientific research evidence and making it widely available to support effective conservation worldwide  Empowering coastal communities to conserve and restore mangroves and fisheries and manage them sustainably  Building farmers’ food and income security with sustainable practices to protect biodiverse forests and wildlife  CHINA  Orda Ethiopia  Restoring and connecting Ethiopia’s sacred forests as a stepping stone to wider restoration of the landscape Conserving biodiversity by supporting sustainable livelihoods in regenerative agriculture, crafts and tourism in the national park buffer zone MOZAMBIQUE  COMOROS  Training and equipping local communities to manage wildlife conservation areas effectively to shape their own futures TANZANIA  NICARAGUA  ETHIOPIA  Protecting leopards by providing synthetic alternatives to the leopard skins used in traditional and religious ceremonies and gatherings SOUTH AFRICA, ZAMBIA  Improving herding practices to regenerate the land, reduce human-wildlife conflict and develop the wildlife economy SOUTH AFRICA, ZAMBIA  MADAGASCAR  Monitoring populations, conserving habitats, and reducing human-wildlife conflict to protect China’s iconic snow leopards  MOROCCO  Gorongosa Restoration Project  Pioneering a conservation scheme that uses cash payments to incentivise farmers to protect intact forests on their land  SAÕ TOMÉ & PRÍNCIPE  GLOBAL  Supporting earthquake-hit communities in the High Atlas to rebuild with vital supplies, livestock feed and sustainable agriculture  GLOBAL  LEBANON  Creating forest conservation incentives for farmers and strengthening the capacity of local conservationists for long-term impact  Reporting on innovative, climate-smart conservation to inform and support effective biodiversity protection  Conserving biodiversity by creating and managing nature reserves that protect habitats and threatened species  Empowering local communities to manage natural resources and protect wildlife through secured legal rights, improved governance and income generation  ECUADOR  NAMIBIA  Helping local communities establish cooperatives that monitor, protect and conserve threatened ecosystems INDONESIA  34"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 35-text\" style=\"top:17px;left:-34px;\" src=\"/AR2024-25/static/_content/35-text-1.png\"/>\n        <img class=\"abs halfScaleC 35-text\" style=\"top:226px;left:-35px;\" src=\"/AR2024-25/static/_content/35-text-2.png\"/>\n        <img class=\"abs halfScaleC 35-text\" style=\"top:46px;left:297px;\" src=\"/AR2024-25/static/_content/35-text-3.png\"/>\n        <img class=\"abs halfScaleC 35-text\" style=\"top:368px;left:-35px;\" src=\"/AR2024-25/static/_content/35-text-4.png\"/>\n        <img class=\"abs halfScaleC 35-text\" style=\"top:185px;left:296px;\" src=\"/AR2024-25/static/_content/35-text-5.png\"/>\n        <img class=\"abs halfScaleC 35-text\" style=\"top:533px;left:-35px;\" src=\"/AR2024-25/static/_content/35-text-6.png\"/>\n        <img class=\"abs halfScaleC 35-text\" style=\"top:303px;left:295px;\" src=\"/AR2024-25/static/_content/35-text-7.png\"/>\n        <img class=\"abs halfScaleC 35-text\" style=\"top:401px;left:296px;\" src=\"/AR2024-25/static/_content/35-text-8.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim.staggerFromTo(cOf(\"35-text\"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1)\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop();\n        }\n      ",
    "searchText": "Restoring the habitats of a fire-ravaged raptor refuge, monitoring wildlife and reducing biodiversity threats Supporting indigenous communities to secure land rights, establish protected areas and develop sustainable incomes  GREECE  PERU  Protecting ecosystems using indigenous fire management that reduces emissions and builds sustainable livelihoods AUSTRALIA  Restoring ecosystems and reintroducing previously lost wild species in degraded landscapes across Europe ROMANIA, SPAIN  Leveraging public, private and philanthropic funding for the future of critical ecosystems and their populations BURUNDI, MALAYSIA, THAILAND  Restoring forest ecosystems, reintroducing key species, and improving food security and cash income with a premium organic crop CAMBODIA  WCS Mongolia  Partnering with herders, authorities and railway operators to protect wildlife habitats and nomadic practices MONGOLIA  Promoting community-led conservation to ensure cultures, people and wildlife thrive in their shared landscape KENYA  35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"top:793px;left:337px;width:170px;height:18px\">\n          <a href=\"https://www.cartierphilanthropy.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"top:811px;left:337px;width:153px;height:18px\">\n          <a href=\"https://www.cartierfornature.org/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n            setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "G OVE RNA N C E Cartier Philanthropy, which hosts Cartier for Nature, is the Maison Cartier’s grant-making foundation. Based in Geneva, Switzerland, it is governed by Swiss law and operates under the supervision of the Federal Supervisory Board for Foundations of the Swiss Federal Department of Home Affairs in Bern. Cartier Philanthropy and Cartier for Nature are funded by Cartier but operate in full independence of its commercial interests. A Board of seven members provides leadership and supervises Cartier Philanthropy’s operations. During the reporting period, the Board members were: Cyrille Vigneron (President of the Board and Chairman of Cartier Culture and Philanthropy), François Lepercq (Treasurer of the Board, Senior VP and Chief Finance Officer of Cartier), and, in alphabetical order, Grégoire Blanche (CEO of Cartier Europe), Erica Lovett (Head of Diversity & Inclusion, Cartier North America), Wendy Luhabe (Non-Executive Director, Richemont), Pierre Rainero (Image, Style and Heritage Director of Cartier), and Jacqueline Ronconi (Head Counsel Cartier, Richemont).  P HOTO C RE D I TS Cover: Ben Buckland / Cartier for Nature P. 2: Iako Randrianarivelo / Fairpicture; Ben Buckland / Cartier for Nature; Sara Hylton / Cartier Philanthropy; Ben Buckland / Cartier for Nature P. 4: Matt Judge / Blue Ventures P. 5: Sara Hylton / Cartier Philanthropy; Andrea Borgarello / Cartier Philanthropy; Karin Schermbrucker / Cartier Philanthropy; Sara Hylton / Cartier Philanthropy; Proximity Designs, Ben Buckland / Cartier for Nature; David Jenike / Soralo; Daniel Mirlea / Rewilding Europe P. 6: Karin Schermbrucker / Cartier Philanthropy P. 9: Ben Buckland / Cartier for Nature P. 12: Andrea Borgarello / Cartier Philanthropy P. 13: Andrea Borgarello / Cartier Philanthropy P. 14: Karin Schermbrucker / Cartier Philanthropy P. 15: Integrate Health P. 16: SmartStart; Andrea Borgarello / Cartier Philanthropy P. 17: Simon Needham / One Heart Worldwide; Madam Khadka / One Heart Worldwide P. 18: Thibault Fendler / MSF; SPBT P. 19: Gareth Whittington-Jones / Panthera; Nikki Le Roex / Panthera; Peace Parks Foundation P. 20: Javier Aznar / Fundación Jocotoco; China Green Foundation P. 21: Proximity Designs P. 22-24: Shatabdi Chakrabarti / Cartier Philanthropy P. 25-26: Ben Buckland / Cartier for Nature P. 27: Mark Godfrey / TNC; Ben Buckland / Cartier for Nature P. 28: Ben Buckland / Cartier Philanthropy P. 32: Karin Schermbrucker / Cartier for Nature P. 34: Ben Buckland / Cartier for Nature P. 35: Ben Buckland / Cartier for Nature  ADD RE S S  W EB SI T ES  Rue André-De-Garrini 3 CH-1217 Meyrin-Genève  www.cartierphilanthropy.org www.cartierfornature.org  The figures in this report reflect data shared by the partner organisations supported by Cartier Philanthropy."
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n\n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'addContentLinkThree'\n        })\n      }\n\n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n\n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n\n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function animateNumbers(klass, delay = 1, stagger = 0.3) {\n        numbers = cOf(klass)\n\n        setTimeout(function() {\n          for (let i = 0; i < numbers.length; i++) {\n            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])\n          }\n        }, delay * 1000)\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-7DBG1R67HY" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V+ca":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rIu8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.772dd89a23c113b934b2.js